import { Button, ButtonsGroup } from '@billy/design-system'
import { ReactElement, useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { useVatDeclarationsDefinePeriodPayoutModal } from '../../context/vatDeclarationsDefinePayoutModalContext'

export const ModalFooter = (): ReactElement => {
  const { t } = useTranslation()
  const { closeModal, submitForm, isProcessing } = useVatDeclarationsDefinePeriodPayoutModal()

  const handleCancelButtonClick = useCallback(() => {
    closeModal()
  }, [closeModal])

  const handleSubmitButtonClick = useCallback(() => {
    submitForm()
  }, [submitForm])

  return (
    <ButtonsGroup>
      <Button onClick={handleCancelButtonClick} variant="text">
        {t('cancel')}
      </Button>
      <Button loading={isProcessing} onClick={handleSubmitButtonClick}>
        {t('vat_declarations.define_payout_modal.save')}
      </Button>
    </ButtonsGroup>
  )
}
